import { useTheme } from "@emotion/react";
import { Box, Tooltip, Typography } from "@mui/material";
import CopyButton from "../copyButton";
import useStyles from "./styles";

// Par rótulo/valor das seções de informação do atendimento.
//
// O layout é empilhado — rótulo acima, valor abaixo — em vez de lado a lado.
// O formato anterior punha os dois na mesma linha com `whiteSpace: nowrap` e
// reticências, o que em telas estreitas cortava justamente o valor: sobrava
// "Endereço Instalação:" e três pontos. Empilhado, o rótulo ocupa a largura
// que precisa e o valor quebra em quantas linhas forem necessárias.
//
// `children` substitui o texto do valor quando o conteúdo é um chip ou outro
// elemento. `copyValue` liga o botão de copiar, que só aparece no hover para
// não poluir a leitura.
export default function InfoField({
  label,
  value,
  children,
  copyValue,
  setSnackbar,
  tooltip,
  sx = {},
}) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const temValor =
    children || (value !== null && value !== undefined && value !== "");
  const conteudo = children || (temValor ? value : "—");

  const corpo = (
    <Box sx={{ ...styles.container, ...sx }}>
      <Typography component="span" sx={styles.rotulo}>
        {label}
      </Typography>

      <Box sx={styles.linhaValor}>
        <Typography
          component="div"
          sx={{
            ...styles.valor,
            color: temValor
              ? theme.palette.text.primary
              : theme.palette.text.disabled,
          }}
        >
          {conteudo}
        </Typography>

        {copyValue && temValor && (
          <Box className="campo-copiar" sx={styles.boxCopiar}>
            <CopyButton
              value={copyValue}
              setSnackbar={setSnackbar}
              title={`Copiar ${label?.toLowerCase()}`}
              mensagem={`${label} copiado!`}
            />
          </Box>
        )}
      </Box>
    </Box>
  );

  if (!tooltip) return corpo;

  return (
    <Tooltip title={tooltip} placement="top-start">
      {corpo}
    </Tooltip>
  );
}
